import React, { useLayoutEffect, useRef, useState } from 'react';
import './OurTeam.css';
import jaredPhoto from '../pictures/jared.jpg';
import yinglingPhoto from '../pictures/yingling.jpg';
import keithPhoto from '../pictures/keith.jpg';
import ginaPhoto from '../pictures/gina.jpg';

// To add a photo for someone else, import it like jaredPhoto above and set `photo` on that
// member below; members without a photo show their initials.
const teamMembers = [
  {
    name: 'Jared M. Knaub',
    title: 'President & CEO',
    credentials: 'B.S. Architectural Engineering',
    initials: 'JK',
    photo: jaredPhoto,
    bio: `Jared Knaub's passion for real estate and property management began long before his professional career. Growing up as the son of a handyman and contractor, Jared spent much of his childhood around construction sites, learning firsthand what it takes to maintain, improve, and transform properties.

While pursuing his degree in Architectural Engineering at the Illinois Institute of Technology, Jared took his first major step into real estate development at just 21 years old, partnering with his parents to acquire and redevelop their first investment property. That experience combined his technical engineering education with his hands-on construction background and sparked a passion for real estate investment, development, and property management.

Following college, Jared began his professional career with Trane Technologies, gaining experience in building systems, energy efficiency, and existing building operations. Today, he serves as President and CEO of Delta Property Management Group and RE/MAX Delta Group, while overseeing a growing portfolio of real estate investment, development, and construction businesses.

With a unique background spanning engineering, construction, real estate brokerage, property management, and development, Jared brings an owner's perspective to every property under management. His approach is rooted in a simple philosophy: manage every property with the same care, attention, and long-term vision as if it were his own.`,
  },
  {
    name: 'Michael Yingling',
    title: 'Vice President/Broker of Record',
    initials: 'MY',
    photo: yinglingPhoto,
    bio: `Michael Yingling started his career in real estate in 1974 with construction and property management with “Service is Job One” as a mission statement, Michael takes pride in making sure that this statement is carried out each and every day by his staff, agents, and himself. Michael purchased his first investment property at 18 years old and, over the years, has built, sold, managed and developed thousands of residential homes, commercial buildings, businesses, and developments. Michael also served as an elected Township Supervisor for over 15 years. Each client is given first-class service for all their needs. Let his half century of experience and knowledge go to work for you, your family, or your organization. We exist to help you grow and prosper, no matter what size your wants, needs, or aspirations are.`,
  },
  {
    name: 'Keith Bauer',
    title: 'Senior Property Manager',
    initials: 'KB',
    photo: keithPhoto,
    bio: `Keith Bauer brings a well-rounded background in property management, real estate investment, construction, and residential and commercial real estate to Delta Property Management Group. With more than a decade of hands-on experience in the remodeling industry, Keith developed a strong understanding of properties from the ground up, beginning his career as a construction business owner and real estate investor.

Building on that foundation, Keith expanded into real estate sales and property management, becoming part of the team that launched Hawkstone Real Estate & Property Management in 2023. His experience working with property owners, investors, buyers, and sellers has given him a practical understanding of both the operational and financial sides of real estate ownership.

Today, as Senior Property Manager at Delta Property Management Group, Keith helps oversee day-to-day property operations, tenant relations, maintenance coordination, and client services. His unique combination of construction knowledge, real estate investment experience, and property management expertise allows him to identify opportunities to improve properties, control expenses, and protect owners' investments.

Keith approaches property management with an owner's mindset, recognizing that successful management goes beyond collecting rent. It's about maintaining strong relationships, protecting property values, and helping owners achieve their long-term investment goals.`,
  },
  {
    name: 'Michael "Mike" Knaub',
    title: 'Maintenance Director',
    credentials: 'Founder | MG&J’s General, LLC',
    initials: 'MK',
    bio: `Michael “Mike” Knaub brings decades of hands-on experience in construction, maintenance, industrial operations, and facility management. A military veteran, Mike built his career through a combination of leadership and technical roles, including management positions in warehouse and distribution operations, followed by work as a field service technician with Modern Forklift.

Throughout his career, Mike developed extensive expertise in industrial electrical controls, equipment troubleshooting, mechanical systems, and building maintenance. His ability to diagnose problems, develop practical solutions, and tackle a wide variety of projects became the foundation for his entrepreneurial career.

In 2009, Mike founded MG&J’s General, LLC, beginning as a one-man operation providing everything from general handyman services and property repairs to renovations, electrical work, and building maintenance. What started with one person and a commitment to quality workmanship has grown into a full-service construction and maintenance company that works closely with Delta Property Management Group.

Today, Mike's decades of technical knowledge, leadership experience, and practical problem-solving continue to play an important role in maintaining and improving the properties entrusted to the company. His approach to every project is guided by a saying that reflects his lifelong commitment to quality workmanship:

“Once a job has begun, never leave it till it's done. Be the job big or small, do it well or not at all.”`,
  },
  {
    name: 'Laura Bomgardner',
    title: 'Director of Finance & Executive Administration',
    initials: 'LB',
  },
  {
    name: 'Jenna Baumbach',
    title: 'Tenant Relations Coordinator',
    initials: 'JB',
    bio: `A graduate of Middletown Area High School, Jenna Baumbach brings a fresh perspective, strong communication skills, and a passion for helping others to Delta Property Management Group.

Before joining the company, Jenna built her professional background in the food service industry, where she developed valuable experience in customer service, multitasking, problem-solving, and working in fast-paced environments. Seeking a new career opportunity, Jenna made the transition into property management and has quickly become an important part of the Delta team.

As Tenant Relations Coordinator, Jenna serves as a key point of contact between tenants and the property management team. She focuses on maintaining clear, consistent communication, addressing tenant questions and concerns, coordinating service requests, and ensuring residents' needs are handled efficiently and professionally.

Since joining Delta Property Management Group, Jenna has demonstrated an exceptional willingness to learn, take initiative, and grow within the organization. Her positive attitude, dedication, and attention to detail help create a welcoming and responsive experience for tenants while supporting the company's commitment to quality property management.

Jenna believes that successful tenant relationships begin with communication, respect, and follow-through, and she works every day to ensure residents feel heard, valued, and supported.`,
  },
  {
    name: 'Regina "Gina" Knaub',
    title: 'Director of Education & Development',
    initials: 'RK',
    photo: ginaPhoto,
    bio: `Gina Knaub brings decades of experience in education, instructional development, and organizational planning to Delta Property Management Group. A longtime educator with the Middletown Area School District, Gina spent her career working in special education, developing individualized learning approaches, implementing structured programs, and helping students achieve their full potential.

Throughout her career in education, Gina developed a strong foundation in curriculum development, communication, documentation, and the creation of effective systems and procedures. Her ability to break down complex information into clear, manageable processes and help individuals succeed has become an invaluable asset to the company's operations.

Today, as Director of Education & Development, Gina applies her educational background to developing and refining Delta Property Management Group's internal processes, standard operating procedures, employee onboarding, and ongoing staff training programs. She works to establish consistent standards across the organization, ensuring team members have the knowledge, resources, and guidance needed to deliver exceptional service to property owners and tenants.

Gina's focus on education, accountability, and continuous improvement plays an important role in building a company where employees are supported, expectations are clear, and quality service remains consistent as the business continues to grow. Her philosophy is rooted in the belief that **a well-trained, well-supported team is the foundation of a successful organization.**`,
  },
  {
    name: 'Dylan Felgenhauer',
    title: 'Director of Technology / Property Manager',
    initials: 'DF',
    bio: 'At just 24 years old, Dylan Felgenhauer is already making an impact in the realms of technology and real estate. Graduating with a degree in Computer Science in August 2023, Dylan joined Delta Group Inc. in July 2024 as the Director of Technology and Property Manager.',
  },
];

// **text** renders as bold.
const renderBold = (text) =>
  text.split('**').map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : part));

const introParagraphs = [
  'At Delta Property Management Group, we believe exceptional property management starts with exceptional people. Our team brings together a diverse range of experience in real estate investment, property development, construction, engineering, education, and customer service. This unique combination allows us to approach property management from every angle, providing owners with knowledgeable guidance and tenants with responsive, reliable service.',
  'As a family-founded and locally operated company, we take pride in building lasting relationships, maintaining high standards, and treating every property as if it were our own.',
  '**Your investment deserves more than someone to collect the rent.** It deserves a dedicated team that understands property ownership, protects your investment, maximizes its potential, and gives you the peace of mind that comes with knowing your property is in capable hands.',
  'Whether you own a single rental property or an extensive real estate portfolio, we’re ready to help you achieve your goals.',
  '**Ready to experience the Delta difference? Contact our team today to discover how we can make your property our priority.**',
];

const TeamCard = ({ member }) => {
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const bioRef = useRef(null);

  // Offer "Read more" only when the collapsed bio is actually cut off.
  useLayoutEffect(() => {
    const el = bioRef.current;
    if (!el) return undefined;
    const check = () => {
      if (!expanded) setCanExpand(el.scrollHeight > el.clientHeight + 1);
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [expanded]);

  return (
    <article className="team-card">
      {member.photo ? (
        <img className="team-photo" src={member.photo} alt={member.name} />
      ) : (
        <div className="team-photo team-photo-placeholder" aria-hidden="true">
          {member.initials}
        </div>
      )}
      <h2 className="team-name">{member.name}</h2>
      <p className="team-title">{member.title}</p>
      {member.credentials && <p className="team-credentials">{member.credentials}</p>}
      {member.bio && (
        <>
          <div
            ref={bioRef}
            className={expanded ? 'team-bio-wrap' : 'team-bio-wrap collapsed'}
          >
            {member.bio.split('\n\n').map((paragraph) => (
              <p className="team-bio" key={paragraph.slice(0, 40)}>
                {renderBold(paragraph)}
              </p>
            ))}
          </div>
          {canExpand && (
            <button
              type="button"
              className="team-read-more"
              aria-expanded={expanded}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Show less' : 'Read more'}
            </button>
          )}
        </>
      )}
    </article>
  );
};

const OurTeam = () => {
  return (
    <div className="our-team-page">
      <section className="team-hero">
        <h1>Meet Our Team</h1>
        <div className="team-hero-rule" />
      </section>

      <section className="team-intro">
        <h2 className="team-intro-heading">Meet the Team Behind Delta</h2>
        <p className="team-intro-tagline">Your Property. Our Priority.</p>
        {introParagraphs.map((paragraph) => (
          <p className="team-intro-text" key={paragraph.slice(0, 40)}>
            {renderBold(paragraph)}
          </p>
        ))}
      </section>

      <section className="team-grid-section">
        <div className="team-grid">
          {teamMembers.map((member) => (
            <TeamCard member={member} key={member.name} />
          ))}
        </div>
      </section>

      <section className="team-mission">
        <h2>Our Mission</h2>
        <p>
          "Service is Job One" is the mission statement we follow, and our mission is to provide
          exceptional property management services that enhance the value of properties while
          creating a positive living experience for tenants.
        </p>
      </section>
    </div>
  );
};

export default OurTeam;
